import ErrorOutline from "@mui/icons-material/ErrorOutline";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import SearchOffOutlined from "@mui/icons-material/SearchOffOutlined";
import ZoomInOutlined from "@mui/icons-material/ZoomInOutlined";
import { Box, Typography } from "@mui/material";
import { mapNoticeTintSx, mapOverlaySx } from "../utils/saleTokens";

export type SaleMapNoticeKind = "tooWide" | "truncated" | "empty" | "error";

interface Props {
  kind: SaleMapNoticeKind | null;
  message: string;
}

/**
 * 地図上の案内バー。外側の領域は常に DOM に置き、中身だけを切り替える
 * （生成と同時に描くと読み上げられない場合があるため）。
 */
export const SaleMapNotice: React.FC<Props> = ({ kind, message }) => (
  <Box
    role="status"
    aria-live="polite"
    aria-atomic
    sx={(theme) => ({
      position: "absolute",
      top: theme.spacing(1),
      right: theme.spacing(1),
      left: theme.spacing(8),
      zIndex: 1000,
      pointerEvents: "none",
    })}
  >
    {kind !== null && (
      <Box
        sx={(theme) => ({
          ...mapOverlaySx(theme),
          position: "static",
          display: "flex",
          alignItems: "flex-start",
          gap: 1,
          ...(kind === "truncated" ? mapNoticeTintSx(theme) : {}),
          // エラーは枠ではなく、左端 4px の error.main の線で示す（/reassist のエラーと同じ型）
          ...(kind === "error"
            ? { borderLeft: `4px solid ${theme.palette.error.main}` }
            : {}),
        })}
      >
        <Box
          sx={(theme) => ({
            display: "flex",
            flexShrink: 0,
            mt: 0.25,
            color:
              kind === "empty"
                ? theme.palette.text.secondary
                : kind === "error"
                ? theme.palette.error.main
                : theme.palette.primary.main,
          })}
        >
          {kind === "tooWide" && (
            <ZoomInOutlined aria-hidden sx={{ fontSize: 20 }} />
          )}
          {kind === "truncated" && (
            <InfoOutlined aria-hidden sx={{ fontSize: 20 }} />
          )}
          {kind === "empty" && (
            <SearchOffOutlined aria-hidden sx={{ fontSize: 20 }} />
          )}
          {kind === "error" && (
            <ErrorOutline aria-hidden sx={{ fontSize: 20 }} />
          )}
        </Box>
        <Typography sx={{ fontSize: 14, lineHeight: 1.6 }}>
          {message}
        </Typography>
      </Box>
    )}
  </Box>
);
